// ── PREZZI IN BASE ALLA ZONA DEL VISITATORE ────────────────────────────
// Rilevata dal fuso orario del browser PRIMA del primo render (il modulo viene valutato prima di React):
// il prezzo giusto compare fin dal primo paint, senza salti di layout. Euro di default.
//   Europe/Zurich (Svizzera, anche Ticino) → CHF · tutto il resto (Italia, San Marino…) → EUR
// EUR e CHF, stessi numeri: libro 27 (barrato 159), bonus 37 / 27 / 27 / 27 / 37 = 155, totale 314 → 27, risparmi 287.

export type Currency = 'EUR' | 'CHF';

/** Spazio indivisibile tra numero e simbolo (« 27 € » non va mai a capo a metà) */
const NBSP = ' ';

const TABLE: Record<Currency, { main: number; anchor: number; bonuses: number[]; symbol: string }> = {
  EUR: { main: 27, anchor: 159, bonuses: [37, 27, 27, 27, 37], symbol: '€' },
  CHF: { main: 27, anchor: 159, bonuses: [37, 27, 27, 27, 37], symbol: 'CHF' },
};

function detectCurrency(): Currency {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (tz === 'Europe/Zurich') return 'CHF';
  } catch (_err) {
    // Intl non disponibile: resta l’euro
  }
  return 'EUR';
}

export const currency: Currency = detectCurrency();
const t = TABLE[currency];

/** Formato italiano: numero, spazio, simbolo → « 27 € », « 27 CHF », « 0,52 € » (decimali con la virgola). */
export function formatMoney(amount: number): string {
  const n = Number.isInteger(amount) ? String(amount) : amount.toFixed(2).replace('.', ',');
  return `${n}${NBSP}${t.symbol}`;
}

const bonusTotal = t.bonuses.reduce((sum, v) => sum + v, 0);
const totalValue = t.anchor + bonusTotal;

export const prices = {
  currency,
  /** Prezzo di oggi senza simbolo (per il prezzo grande dell’offerta) */
  amount: String(t.main),
  symbol: t.symbol,
  main: formatMoney(t.main),
  anchor: formatMoney(t.anchor),
  bonuses: t.bonuses.map(formatMoney),
  bonusTotal: formatMoney(bonusTotal),
  totalValue: formatMoney(totalValue),
  savings: formatMoney(totalValue - t.main),
  perWeek: formatMoney(Math.round((t.main / 52) * 100) / 100),
};
